module.exports = __webpack_public_path__ + "static/technologies-72fb94a7c3c29dbe10dc81cbcdad9507.jpg";